import { createEnv } from '@t3-oss/env-core'
import * as z from 'zod'

export const env = createEnv({
  server: {
    ADMIN_API_SECRET: z.string().min(1),
    STRIPE_SECRET_KEY: z.string().min(1),
    CLERK_SECRET_KEY: z.string().min(1),
    CLERK_PUBLISHABLE_KEY: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_PURPOSITY_ADMIN_SITE: z.string().min(1),
  },
  runtimeEnv: {
    ADMIN_API_SECRET: process.env.ADMIN_API_SECRET,
    STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
    CLERK_SECRET_KEY: process.env.CLERK_SECRET_KEY,
    CLERK_PUBLISHABLE_KEY: process.env.CLERK_PUBLISHABLE_KEY,
    NEXT_PUBLIC_PURPOSITY_ADMIN_SITE: process.env.NEXT_PUBLIC_PURPOSITY_ADMIN_SITE,
  },
  onInvalidAccess: (v) => {
    throw new Error(`❌ Invalid Access from $/env: ${v}`)
  },
  onValidationError(n) {
    throw (console.error('\u274C Invalid environment variables:', n.flatten().fieldErrors), new Error(`Invalid environment variables: ${Object.keys(n.flatten().fieldErrors).join(', ')}`))
  },
  skipValidation: process.env.SKIP_ENV_VALIDATION === 'true',
})
